import * as React from "react";
const SvgExpand = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.297 9 5 9.703 2.203 12.5H5V14H0V9h1.5v2.797zM12.5 0H14v5h-1.5V2.203L9.703 5 9 4.297 11.797 1.5H9V0z" }));
export default SvgExpand;
